import React, { useState, useEffect, useRef, useCallback } from "react";
import "./header.css";
// import Logo from "../../assets/images/main-logo-03.png";
import { ReactComponent as Logo } from "../../assets/images/main-logo-03.svg";

import { FaShoppingCart, FaSearch } from "react-icons/fa";
import { useUser } from "../../context/UserContext";
import { MdLightMode, MdDarkMode } from "react-icons/md";
import { BalanceDisplay } from "./balance-display";
import socket from "../../services/socket";
import { useNavigate } from "react-router-dom";

const searchSuggestions = [
  "Steam Wallet 100$",
  "Google Play Gift Card",
  "PUBG Mobile UC",
  "Xbox Game Pass",
  "Netflix Subscription",
  "Spotify Premium",
];

const NOTION_LINK = 'https://www.notion.so/iampesmobile/H-NG-D-N-S-D-NG-26d9420ce03480e686fcf51026bfab0b';

const Header = () => {
  const { user, updateBalance, cart } = useUser();
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isMobileSearchActive, setIsMobileSearchActive] = useState(false);

  const [placeholder, setPlaceholder] = useState("");
  const [placeholderIndex, setPlaceholderIndex] = useState(0); // Character index
  const [textIndex, setTextIndex] = useState(0); // Which phrase
  const fullPlaceholder = [
    "Khám phá sản phẩm hot",
    "Tìm nhanh, mua dễ",
    "Khám phá các lựa chọn",
  ];
  const navigate = useNavigate();

  const searchRef = useRef(null);

  const handleUpdateUserBalance = useCallback(
    async ({ newBalance }) => {
      await updateBalance(newBalance);
    },
    [updateBalance]
  );

  useEffect(() => {
    if (user?._id && socket) {
      socket.on("order_success", handleUpdateUserBalance);
      socket.on("markAsFailed", handleUpdateUserBalance);
      socket.on("admin_modify_balance", handleUpdateUserBalance);

      return () => {
        socket.off("order_success", handleUpdateUserBalance);
        socket.off("markAsFailed", handleUpdateUserBalance);
        socket.off("admin_modify_balance", handleUpdateUserBalance);
      };
    }
  }, [user?._id, handleUpdateUserBalance]);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsMobileSearchActive(false);
        document.body.style.overflow = "auto"; // Reset scrolling
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    let intervalId;

    const currentText = fullPlaceholder[textIndex];

    if (placeholderIndex < currentText.length) {
      intervalId = setInterval(() => {
        setPlaceholder(currentText.substring(0, placeholderIndex + 1));
        setPlaceholderIndex((prev) => prev + 1);
      }, 100);
    } else {
      clearInterval(intervalId);
      // After typing is done, wait 2 seconds then move to next phrase
      setTimeout(() => {
        setPlaceholder("");
        setPlaceholderIndex(0);
        setTextIndex((prev) => (prev + 1) % fullPlaceholder.length);
      }, 2000);
    }

    return () => clearInterval(intervalId);
  }, [placeholderIndex, textIndex, fullPlaceholder]);

  useEffect(() => {
    if (searchTerm) {
      const matches = searchSuggestions.filter((item) =>
        item.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredSuggestions(matches);
      setShowDropdown(matches.length > 0);
    } else {
      setShowDropdown(false);
    }
  }, [searchTerm]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowDropdown(false);
        document.body.style.overflow = "auto";
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Toggle bottom-header on mobile when search icon is clicked
  const handleSearchClick = () => {
    if (window.innerWidth <= 768) {
      // Mobile width
      setIsMobileSearchActive((prevState) => {
        const newState = !prevState;
        document.body.style.overflow = newState ? "hidden" : "auto";
        return newState;
      });
    }

    navigate('/search');
  };

  const [darkMode, setDarkMode] = useState(
    localStorage.getItem("theme") === "dark"
  );

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("dark-theme");
      localStorage.setItem("theme", "dark");
    } else {
      document.body.classList.remove("dark-theme");
      localStorage.setItem("theme", "light");
    }
  }, [darkMode]);

  return (
    <>
      <div className="top-header">
        <div className="top-header-link-container">
          <a className="top-header-link" href={NOTION_LINK}>
            Hướng dẫn
          </a>
          {/* <a className="top-header-link" href="/">
            Tuyển dụng
          </a> */}
        </div>
        <div className="toggle-theme-mode-container">
          {darkMode ? (
            <MdDarkMode className="theme-icon" />
          ) : (
            <MdLightMode className="theme-icon" />
          )}
          <button
            className={`toggle-btn ${darkMode ? "active" : ""}`}
            onClick={() => setDarkMode(!darkMode)}
          >
            <div className="toggle-circle"></div>
          </button>
        </div>
      </div>
      <header className="header">
        <div className="header-container">
          <div className="logo-container">
            <a href="/">
              {/* <img src={Logo} alt="Logo" className="header-logo" /> */}
              <Logo className="header-logo" fill="currentColor" />
            </a>
          </div>

          <nav className="nav-menu">
            <ul>
              <li>
                <a href="/category/game-account">TÀI KHOẢN GAME</a>
              </li>
              <li>
                <a href="/category/top-up">NẠP GAME MOBILE</a>
              </li>
              <li>
                <a href="/category/utility-account">TIỆN ÍCH</a>
              </li>
              <li>
                <a href="/category/gift-card">GIFT CARD</a>
              </li>
              <li>
                <a href="/konami-code">KONAMI CODE</a>
              </li>
            </ul>
          </nav>

          <div className="header-right">
            <div className="header-search" ref={searchRef}>
              <input
                type="text"
                placeholder={placeholder}
                className="search-input"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onFocus={() => navigate('/search')}
                readOnly
              />
              <FaSearch
                className="header-search-icon"
                onClick={handleSearchClick}
              />

              {/* {showDropdown && (
                <ul className="autocomplete-dropdown">
                  {filteredSuggestions.map((item, index) => (
                    <li key={index} onClick={() => setSearchTerm(item)}>
                      {item}
                    </li>
                  ))}
                </ul>
              )} */}
            </div>

            <div className="header-icons">
              <div className="cart-container">
                <a href="/cart" className="icon">
                  <FaShoppingCart className="cart-icon"/>
                  {cart > 0 && (
                    <span className="cart-count">{cart}</span>
                  )}
                </a>
              </div>
              {user ? (
                <div className="user-info">
                  <a href="/payment" className="user-balance">
                    <BalanceDisplay />
                    {/* <span className="balance">{user?.balance.toLocaleString() || 0}đ</span> */}
                  </a>
                  <a href="/account">
                    <img
                      src={
                        user?.profileImg ||
                        "https://cdn1.iconfinder.com/data/icons/user-pictures/101/malecostume-512.png"
                      }
                      alt="User Avatar"
                      className="user-avatar"
                    />
                  </a>
                </div>
              ) : (
                <div className="auth-links">
                    <a href="/login">Đăng nhập</a>
                    <a href="/register">Đăng kí</a>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>

      {/* Bottom header that appears on mobile */}
      {/* <div className={`bottom-header ${isMobileSearchActive ? "show" : ""}`}>
        <div className="mobile-search-bar">
          <input
            type="text"
            placeholder="Tìm kiếm"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="mobile-search-input"
          />
        </div>
      </div> */}
    </>
  );
};

export default Header;
